import { render, staticRenderFns } from "./burger.vue?vue&type=template&id=7dd766a8&scoped=true&"
var script = {}
import style0 from "./burger.vue?vue&type=style&index=0&id=7dd766a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd766a8",
  null
  
)

export default component.exports